import React, { FC, useState } from 'react';
import { MultiValue } from 'react-select';
import SectionTitle from '@src/components/SectionTitle';
import { IndustryType, useIndustriesQuery } from '@src/graphql/generated';
import { Option } from '@src/components/Select/interfaces/option.interface';
import { MultiSelectDropdownInput } from '@src/components/Select/MultiSelectDropdownInput';
import { IndustriesProps } from './props';
import './styles.scss';

const INDUSTRIES_LIMIT = 8;

export const Industries: FC<IndustriesProps> = ({ onChange, value }) => {
  const industriesToOptions = (industries: (Pick<IndustryType, 'id' | 'name'> | null)[]): Option[] => {
    return (
      industries
        .filter((industry): industry is Pick<IndustryType, 'id' | 'name'> => !!industry?.id && !!industry?.name)
        .map(industry => {
          return {
            label: industry.name,
            value: industry.id,
          };
        }) || []
    );
  };

  const [selectedIndustries, setSelectedIndustries] = useState<MultiValue<Option>>(industriesToOptions(value || []));

  const { data: industriesData, loading: isLoading } = useIndustriesQuery();

  const industriesOptions: Option[] = industriesToOptions(industriesData?.industries || []);

  const handleChange = (selectedOptions: MultiValue<Option>): void => {
    const selectedIndustries =
      industriesData?.industries.filter((industry): industry is Pick<IndustryType, 'id' | 'name'> =>
        selectedOptions.some(option => option.value === industry?.id),
      ) || [];

    if (selectedIndustries) {
      setSelectedIndustries(selectedOptions);

      onChange(selectedIndustries);
    }
  };

  return (
    <div className="industries">
      <SectionTitle size="S" title={`Industries (up to ${INDUSTRIES_LIMIT})`} />

      <MultiSelectDropdownInput
        value={selectedIndustries}
        onChange={handleChange}
        options={(value || []).length >= INDUSTRIES_LIMIT || isLoading ? [] : industriesOptions}
        placeholder="Please select"
      />
    </div>
  );
};
